import React from "react";
import { Input } from "../input";
import Select from "../select";
import { FormField } from "../utils/fields/FormField";

class PersonalDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { genders, sectors, textsMapping } = this.props;

    return (
      <section className="checkout-section personal-details">
        <h3 className="checkout-section__title">
          {textsMapping.personalDetailsTitle}
        </h3>
        <p>{textsMapping.personalDetailsText}</p>

        <Select
          resourcedTexts={textsMapping}
          inputLabel={textsMapping.personalDetailsSalutation}
          options={genders}
          path="customerData.personalDetails.salutation"
          placeHolder={textsMapping.personalDetailsSalutationDefaultValue}
          required
        />

        <FormField.Group>
          <Input
            resourcedTexts={textsMapping}
            inputType="text"
            inputLabel={textsMapping.personalDetailsInitialsLabel}
            placeHolder={textsMapping.personalDetailsInitialsPlaceholder}
            path="customerData.personalDetails.initials"
            classNames="grid-cell-4"
            required
          />

          <Input
            resourcedTexts={textsMapping}
            inputType="text"
            inputLabel={textsMapping.personalDetailsFirstNameLabel}
            placeHolder={textsMapping.personalDetailsFirstNamePlaceholder}
            path="customerData.personalDetails.firstName"
            classNames="grid-cell-4"
            required
          />

          <Input
            resourcedTexts={textsMapping}
            inputType="text"
            inputLabel={textsMapping.personalDetailsInsertionLabel}
            placeHolder={textsMapping.personalDetailsInsertionPlaceholder}
            path="customerData.personalDetails.insertion"
            classNames="grid-cell-4"
          />

          <Input
            resourcedTexts={textsMapping}
            inputType="text"
            inputLabel={textsMapping.personalDetailsLastNameLabel}
            placeHolder={textsMapping.personalDetailsLastNamePlaceholder}
            id={textsMapping.personalDetailsLastNameLabel.toLowerCase()}
            path="customerData.personalDetails.lastName"
            classNames="grid-cell-4"
            required
          />
        </FormField.Group>

        <Input
          resourcedTexts={textsMapping}
          inputType="text"
          inputLabel={textsMapping.personalDetailsDateOfBirthLabel}
          placeHolder={textsMapping.personalDetailsDateOfBirthPlaceholder}
          path="customerData.personalDetails.dateOfBirth"
          errorMessage={textsMapping.inputErrorMessageDateOfBirth}
          isDate={true}
          required
        />

        <Select
          resourcedTexts={textsMapping}
          inputLabel={textsMapping.personalDetailsSectorsLabel}
          options={sectors}
          path="customerData.personalDetails.sector"
          placeHolder={textsMapping.personalDetailsSectorDefaultValue}
          required
        />

        <Input
          resourcedTexts={textsMapping}
          inputType="text"
          inputLabel={textsMapping.personalDetailsFunctionLabel}
          placeHolder={textsMapping.personalDetailsFunctionPlaceholder}
          path="customerData.personalDetails.functionTitle"
          required
        />
      </section>
    );
  }
}

export default PersonalDetails;
